module.exports = __webpack_public_path__ + "img/cross4green.4cf3cf43.png";